<mat-card
  class="dashboard-card"
  [style.--card-accent]="accentColor"
  [class.content-padding-sm]="resolvedContentPadding === 'sm'"
  [class.content-padding-md]="resolvedContentPadding === 'md'"
  [class.footer-align-start]="footerAlign === 'start'"
  [class.footer-align-between]="footerAlign === 'between'"
  [class.footer-align-end]="footerAlign === 'end'">
  <mat-card-header>
    <mat-card-title
      [class.card-title-link]="titleLink"
      [routerLink]="titleLink"
      [queryParams]="titleQueryParams">
      <mat-icon>{{ icon }}</mat-icon>
      <span class="title-text">
        <span class="title-main">{{ title }}</span>
        <span class="title-subtitle" *ngIf="subtitle">{{ subtitle }}</span>
      </span>
    </mat-card-title>

    <div class="header-actions">
      <ng-content select="[card-actions]"></ng-content>
      <span
        class="count-badge"
        [class.count-badge--soft]="badgeVariant === 'soft'"
        *ngIf="badge !== null"
        [matTooltip]="badgeTooltip">
        {{ badge }}
      </span>
    </div>
  </mat-card-header>

  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

  <mat-card-content>
    <div class="card-empty-state card-error-state" *ngIf="hasErrorState">
      <mat-icon>{{ resolvedErrorIcon }}</mat-icon>
      <p>{{ resolvedErrorMessage }}</p>
      <button
        mat-stroked-button
        type="button"
        class="retry-button"
        (click)="retry.emit()">
        <mat-icon>refresh</mat-icon>
        <span>{{ retryLabel }}</span>
      </button>
    </div>

    <div class="card-empty-state" *ngIf="hasEmptyState">
      <mat-icon>{{ resolvedEmptyIcon }}</mat-icon>
      <p>{{ resolvedEmptyMessage }}</p>
    </div>

    <div class="card-content-body" *ngIf="!isLoading && !hasErrorState && !hasEmptyState">
      <ng-content select="[card-content]"></ng-content>
    </div>

    <div class="card-footer" *ngIf="showFooter">
      <ng-content select="[card-footer]"></ng-content>
    </div>
  </mat-card-content>
</mat-card>
